<template>
  <span>
    <a
      href="#"
      @click.prevent="dialogVisible = true"
      class="btn-danger-outline justify-start w-full mt-2 text-base"
    >
      <svg class="mr-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
      </svg>
      {{ $t('Delete') }}
    </a>

    <DialogModel
      :title="$t('Delete this idea?')"
      :message="$t('This will permanently delete this idea and all of its comments and votes. This action cannot be undone.')"
      :button-text="$t('Delete')"
      @done="deletePost"
      @cancel="dialogVisible = false"
      v-if="dialogVisible"
    />
  </span>
</template>

<script>
import DialogModel from "../components/dialog_model";

export default {
  props: ["delete-url"],
  data() {
    return {
      dialogVisible: false,
    };
  },
  components: {
    DialogModel,
  },
  methods: {
    deletePost() {
      Rails.ajax({
        url: this.deleteUrl,
        type: "DELETE",
        beforeSend: function () {
          return true;
        },
        success: () => {},
        error: (data) => {
          console.error("Error deleting post:", data);
        },
      });
    },
  },
};
</script>
